import axios from "@/libs/api.request";

export const getGroupBuyList = filterCond => {
  return axios.request({
    url: "groupbuy/getGroupBuyList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};

export const searchGoodsList = name => {
  return axios.request({
    url: "groupbuy/searchGoodsList",
    data: { name },
    csrf: false,
    method: "post"
  });
};

export const storeGroupBuyData = data => {
  return axios.request({
    url: "groupbuy/storeGroupBuyData",
    data: data,
    csrf: false,
    method: "post"
  });
};
